export const braindateUrl = 'https://braindate.com/';
export const mainContentId = 'main-content';
export const newTopicButtonPortal = 'new-topic-button';
export const notificationsMenuId = 'notifications-menu';
